const CORPORATE_ROLES = new Set(['insurance', 'business']);
const WEB_PATHS = ['/insurance', '/business', '/docs/aseguradoras', '/admin/insurance-access',
  '/admin/settings/insurers', '/admin/settings/corporate', '/admin/insurers', '/admin/corporate'];
const PUBLIC_ACCOUNT_PATHS = ['/login', '/verify-access', '/change-password', '/forgot-password',
  '/reset-password', '/activate', '/privacy', '/privacy-policy', '/terms', '/terms-and-conditions', '/contact'];
const inside = (path, prefix) => path === prefix || path.startsWith(prefix + '/');
const pathname = value => {
  const path = String(value || '/').split(/[?#]/, 1)[0];
  try { return decodeURIComponent(path).replace(/\/+$/, '') || '/'; } catch { return path; }
};

export const isCorporateWebRole = role => CORPORATE_ROLES.has(role);
export const isCorporateWebPath = path => WEB_PATHS.some(prefix => inside(pathname(path), prefix));

export function requiresCorporateWeb({ native, user, path, search = '' }) {
  if (!native) return false;
  const current = pathname(path);
  if (isCorporateWebPath(current)) return true;
  const portal = new URLSearchParams(search).get('portal');
  if (current === '/login' && ['insurance', 'business'].includes(portal)) return true;
  if (!isCorporateWebRole(user?.role)) return false;
  return !PUBLIC_ACCOUNT_PATHS.some(prefix => inside(current, prefix));
}

export function corporateWebDestination({ backendOrigin, role } = {}) {
  let origin = 'https://www.cainversionesservicios.com';
  try {
    const candidate = new URL(backendOrigin);
    if (candidate.protocol === 'https:' && !candidate.username && !candidate.password
        && candidate.hostname.endsWith('.preview.emergentagent.com')) origin = candidate.origin;
  } catch { /* Production and malformed/missing configuration use the official website. */ }
  return origin + (role === 'business' ? '/business' : '/insurance');
}
